import parse from 'html-react-parser';
import { useLoaderData } from 'react-router';
import PageImage from '~/layout/public/page-image';
import type { Course } from '~/models/course';
import { useCoursesData } from '~/routes/courses/layout';
import ContactForm from '../contact/contact-form';
import { buildCourseSchema } from '~/lib/schema/course';
import { JsonLd } from '~/components/seo/JsonLd';

interface Props {
    activeCourse: Course | null | undefined;
}

export default function CourseDetailsSection() {
    const { courseDetails } = useCoursesData();
    if (!courseDetails) {
        throw new Response("No course found", {
            status: 404,
            statusText: "No course found",
            headers: { "Content-Type": "text/plain" }
        });
    }
    const courseSchema = buildCourseSchema(courseDetails);
    const { formRef, formSig } = useLoaderData<{ formRef: string, formSig: string }>();
    return (
        <>
            <section id="course-details" className="course-details">
                <div className="container" data-aos="fade-up">
                    {courseDetails &&
                        <div className="row">
                            <div className="col-lg-7 order-2 order-lg-1">
                                <h2 className="primary">{courseDetails.name}</h2>
                                {parse(courseDetails.details)}
                                <div className="d-lg-none d-block">
                                    <ContactForm formRef={formRef} formSig={formSig} subjectOverride={courseDetails.name} />
                                </div>
                            </div>
                            <div className="col-lg-5 order-1 order-lg-2">
                                {/* <div className="course-info d-flex justify-content-between align-items-center">
                                <h5>Course Title</h5>
                                <p><a href="#">{activeCourse?.name}</a></p>
                            </div> */}
                                <PageImage
                                    cldUrl={courseDetails.largeImage ?? undefined}
                                    src={courseDetails.largeImage ? undefined : '/img/defaultCourseDetails.jpeg'}
                                    alt={courseDetails.name}
                                />
                                {/* <div className="course-info d-flex justify-content-between align-items-center">
                                <h5>Cost</h5>
                                <p>£{activeCourse?.baseCostPP}</p>
                            </div> */}
                                <div className="d-lg-block d-none">
                                    <ContactForm formRef={formRef} formSig={formSig} subjectOverride={courseDetails.name} />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </section>

            {/* JSON-LD */}
            <JsonLd data={courseSchema} />
            {/* <JsonLd data={faqSchema} />
            <JsonLd data={instanceSchema} /> */}
        </>
    )
}